/* ============================================================
   Floating Submit Panel — Dawn OS 2.0
   ============================================================ */

(function () {
  'use strict';

  function initFloatingSubmitPanel(root) {
    const trigger  = root.querySelector('[data-fsp-trigger]');
    const panel    = root.querySelector('[data-fsp-panel]');
    const backdrop = root.querySelector('[data-fsp-backdrop]');
    const closes   = root.querySelectorAll('[data-fsp-close]');
    const copyBtn  = root.querySelector('[data-fsp-copy-caption]');

    if (!trigger || !panel) return;

    // --- Position trigger based on data attribute ---
    const pos = root.dataset.fspPos || 'top-right';
    const offX = root.dataset.fspOffX || '24';
    const offY = root.dataset.fspOffY || '24';

    root.style.setProperty('--fsp-toff-x', offX + 'px');
    root.style.setProperty('--fsp-toff-y', offY + 'px');
    root.setAttribute('data-fsp-pos', pos);

    // --- Open ---
    function openPanel() {
      panel.removeAttribute('hidden');
      // Defer so CSS transition plays
      requestAnimationFrame(() => {
        panel.classList.add('is-active');
        backdrop.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';

        // Focus first focusable element inside panel
        const firstFocusable = panel.querySelector(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (firstFocusable) firstFocusable.focus();
      });
    }

    // --- Close ---
    function closePanel() {
      panel.classList.remove('is-active');
      backdrop.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';

      // Re-hide after transition
      panel.addEventListener('transitionend', function onEnd() {
        panel.setAttribute('hidden', '');
        panel.removeEventListener('transitionend', onEnd);
      }, { once: true });

      trigger.focus();
    }

    // --- Events ---
    trigger.addEventListener('click', () => {
      const isOpen = !panel.hasAttribute('hidden') && panel.classList.contains('is-active');
      isOpen ? closePanel() : openPanel();
    });

    backdrop.addEventListener('click', closePanel);

    closes.forEach(btn => btn.addEventListener('click', closePanel));

    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !panel.hasAttribute('hidden')) {
        closePanel();
      }
    });

    // Focus trap inside panel
    panel.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const focusable = Array.from(panel.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(el => !el.closest('[hidden]'));

      if (!focusable.length) return;
      const first = focusable[0];
      const last  = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // --- Copy Caption ---
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        const captionEl = root.querySelector('[data-fsp-caption-text]');
        const text = captionEl
          ? (captionEl.dataset.fspCaptionText || captionEl.textContent)
          : '';

        if (!text) return;

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(() => flashCopied(copyBtn));
        } else {
          // Fallback
          const ta = document.createElement('textarea');
          ta.value = text;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          flashCopied(copyBtn);
        }
      });
    }

    function flashCopied(btn) {
      const span = btn.querySelector('span');
      const original = span ? span.textContent : '';
      btn.classList.add('is-copied');
      if (span) span.textContent = 'Copied!';
      setTimeout(() => {
        btn.classList.remove('is-copied');
        if (span) span.textContent = original;
      }, 2000);
    }
  }

  // Init all panels on page
  function init() {
    document.querySelectorAll('.fsp-root').forEach(initFloatingSubmitPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();